import { render, staticRenderFns } from "./email.vue?vue&type=template&id=d31d5edc"
import script from "./email.ts?vue&type=script&lang=js&external"
export * from "./email.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports